module.exports = __webpack_public_path__ + "static/media/projects1.e3b1d4c0.jpg";